import storage from './storage'
// import store from '../store/index'
import { shoes } from '../config/index'
import { GetRequestParam } from './browser'

// 存储数据
const storageKey = 'pages'
const b = GetRequestParam('b')
const urlKey = encodeURIComponent(window.location.origin + window.location.pathname + '?b=' + b)
// const urlKey = encodeURIComponent(window.location.href)
export function setToStorage(obj) {
  const res = getStorage() ? getStorage() : {}
  res[urlKey] = obj
  storage.setItem(storageKey, JSON.stringify(res))
}

// 获取存的数据，如果没有返回 null
export function getStorage() {
  let obj = storage.getItem(storageKey)
  try {
    obj = JSON.parse(obj)
  } catch (e) {
    obj = null
  }
  return obj
}

// 是否已经加速过。可能到第2页 或者 第4页
// 根据存的数组中的url和当前url对比
export function isAlready(obj) {
  if (!obj) {
    return false
  }
  return obj[urlKey]
}

// 添加日期记录
function formatDate() {
  const time = new Date()
  const year = time.getFullYear()
  const month = time.getMonth() + 1
  const day = time.getDate()
  return `${year}-${month}-${day}`
}
function getDate() {
  let arr = storage.getItem('dateStr')
  try {
    arr = JSON.parse(arr)
    !Array.isArray(arr) && (arr = [])
  } catch (e) {
    arr = []
  }
  return arr
}
export function setDate() {
  const arr = getDate()
  arr.push(formatDate())
  storage.setItem('dateStr', JSON.stringify(arr))
}
export function dateAlready() {
  const arr = getDate()
  const today = formatDate()
  let count = 0
  arr.forEach(date => {
    date === today && count++
  })
  return count >= 3
}

// 返回用户头像地址
export function checkIcon (passicon, usericon) {
  const urlHost = process.env.VUE_APP_PUBLIC_PATH
  const urlAvatar = process.env.VUE_APP_URL_AVATAR
  if (passicon === null || passicon === '') {
    if (usericon === null || usericon === '') {
      usericon = `${urlHost}img/Icon_8.png`
    } else {
      usericon = `${urlHost}img/Icon_${usericon}.png`
    }
  } else {
    usericon = `${urlAvatar}/${passicon}`
  }
  return usericon
}

// 1. 如果是苹果的话：离开qq/微信，直接开启游戏；没有游戏，打开到appstore下载页
// 2. 如果是安卓的话：点击打开球球，没有的话引导去浏览器下载
export function openApp() {
  const ua = window.navigator.userAgent
  const android = ua.match(/Android/i) !== null
  const ios = ua.match(/iPad|iPod|iPhone/i) !== null
  const wechat = ua.match(/MicroMessenger/i) !== null
  const weibo = ua.match(/Weibo/i) !== null
  if (ios) {
    if (wechat || weibo) {
      window.location.href = 'https://apps.apple.com/cn/app/id996509117'
    } else {
      // ios app协议
      window.location.href = 'qiuqiudazuozhan://'
      window.setTimeout(function() {
        window.location.href = 'https://apps.apple.com/cn/app/id996509117'
      }, 2000)
    }
  } else if (android) {
    // if (wechat || weibo) {
    //   store.commit('setWechat', true)
    // } else {
    // android app协议
    window.location.href = 'qiuqiudazuozhan://app'
    window.setTimeout(function() {
      window.location.href = '//www.battleofballs.com/index_mobile.html?type=open'
    }, 2000)
    // }
  }
}

export function getShoe(shoeid) {
  const id = shoeid ? parseInt(shoeid) : 2114
  let obj = {}
  shoes.forEach(item => {
    parseInt(item.id) === parseInt(id) && (obj = item)
  })
  obj.img = `${process.env.VUE_APP_PUBLIC_PATH}img/${obj.icon}.png`
  obj.logo = `${process.env.VUE_APP_PUBLIC_PATH}img/${obj.iconlogo}.png`
  return obj
}

// 获取随机的index
export function getRandomIndex(weight) {
  const arrWeight = arrOverAdd(weight)
  const totalWeight = arrWeight[arrWeight.length - 1]
  const random = Math.random() * totalWeight
  return getArrIndex(random, arrWeight)
}
// 数组元素叠加 [1,2,3,4,,] -> [1,3,6,10,,,,]
function arrOverAdd(arr) {
  if (!arr || arr.length <= 0) {
    return []
  }
  const temp = []
  let total = 0
  for (let i = 0; i < arr.length; i++) {
    total += parseInt(arr[i])
    temp.push(total)
  }
  return temp
}
/**
* 获取数组中最接近的值得index
* @param random 随机数
* @param weightArray 权重数组
* @returns {number}
*/
function getArrIndex(random, arrWeight) {
  const len = arrWeight.length
  if (random <= arrWeight[0]) {
    return 0
  } else if (random >= arrWeight[len - 1]) {
    return len - 1
  }
  let index = 0
  for (let i = 0; i < len; i++) {
    if (random <= arrWeight[i]) {
      index = i
    } else if (random > arrWeight[i] && random <= arrWeight[i + 1]) {
      index = i + 1
      break
    }
  }
  return index
}
